// extracted by mini-css-extract-plugin
export default {"close":"styles_close__up+7F"};